const data = {
  voucher: require('./voucher.js'),
  cinemaDeal: require('./cinemaDeal.js'),
  socialDeal: require('./socialDeal.js'),
  steakMenu: require('./steakMenu.js'),
  kidsMenu: require('./kidsMenu.js'),
  voucherThreeCourse: require('./voucherThreeCourse.js'),
  voucherLunchdeal: require('./voucherLunchdeal.js')
}

module.exports = data
